const normalize = (text: string) => text.normalize('NFD').replace(/([\u0300-\u036f]|[^0-9a-zA-Z])/g, '').toLowerCase();

const strings = { normalize };

export default strings;
